import { render, staticRenderFns } from "./CommissionImports.vue?vue&type=template&id=31c0eda3"
import script from "./CommissionImports.vue?vue&type=script&lang=js"
export * from "./CommissionImports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports